import { render, staticRenderFns } from "./_jili.vue?vue&type=template&id=bc502508&lang=pug&"
import script from "./_jili.vue?vue&type=script&lang=js&"
export * from "./_jili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports